import { reportActions } from '../../reducers/report'
import { AppDispatch } from '../../store'
import { Report } from '../../../shared/model/models'

export const changeCurrentReport = (report: Report) => (dispatch: AppDispatch) => {
  dispatch(reportActions.setCurrentReport(report))
}

export * from './thunk'
